import React, { useState } from 'react';
type Plan = {
  id: 'essential' | 'pro';
  badge?: string;
  label: string;
  title: string;
  subtitle: string;
  oldPrice: string;
  price: string;
  url: string;
  highlight?: boolean;
  features: string[];
};
const PLANS: Plan[] = [{
  id: 'essential',
  label: 'Plan Esencial',
  title: 'Kit Anticontracturas',
  subtitle: '4 Tomos + 4 Bonos',
  oldPrice: '$55.990',
  price: '$19.990',
  url: 'https://www.nexorecursos.com/cart/52559866462484:1',
  features: ['4 Tomos completos', '4 Bonos de acción inmediata', 'Acceso inmediato 100% digital']
}, {
  id: 'pro',
  badge: '⭐ Más elegido',
  label: 'Plan PRO',
  title: 'Kit + PRO',
  subtitle: '4 Tomos + 4 Bonos + PRO',
  oldPrice: '$75.990',
  price: '$27.990',
  url: 'https://www.nexorecursos.com/cart/52560003760404:1',
  highlight: true,
  features: ['Todo del Plan Esencial', '+ Sistema PRO (4 módulos)', '+ Liberación miofascial y fortalecimiento']
}];
const PRO_URL = 'https://www.nexorecursos.com/cart/52560003760404:1';
const PRO_FEATURES = ['Protocolo Intensivo 7 Días', 'Liberación Miofascial Avanzada', 'Fortalecimiento 8 Semanas', 'Protocolo Para Cualquier Contexto'];
function UpsellBanner() {
  return <div className="relative gold-shimmer-border my-3 sm:my-4 animate-fade-in-up" data-id="element-33">
      {/* Corner sparkles */}
      <span className="gold-corner-sparkle" style={{
      top: -6,
      left: -6,
      animationDelay: '0s'
    }} aria-hidden="true" data-id="element-34">
        ✨
      </span>
      <span className="gold-corner-sparkle" style={{
      top: -6,
      right: -6,
      animationDelay: '0.5s'
    }} aria-hidden="true" data-id="element-35">
        ✨
      </span>
      <span className="gold-corner-sparkle" style={{
      bottom: -6,
      left: -6,
      animationDelay: '1s'
    }} aria-hidden="true" data-id="element-36">
        ✨
      </span>
      <span className="gold-corner-sparkle" style={{
      bottom: -6,
      right: -6,
      animationDelay: '1.5s'
    }} aria-hidden="true" data-id="element-37">
        ✨
      </span>

      {/* Inner dark-navy content */}
      <div className="rounded-[calc(1rem-2px)] p-3 sm:p-4 text-center relative overflow-hidden" style={{
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
    }} data-id="element-38">
        {/* Top badge */}
        <div className="inline-block px-2.5 py-0.5 sm:px-3 sm:py-1 rounded-full text-[8px] sm:text-[10px] font-extrabold tracking-[0.2em] uppercase mb-2 sm:mb-3 shadow-md" style={{
        background: 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)',
        color: '#1a2744'
      }} data-id="element-39">
          ✨ Oferta Exclusiva ✨
        </div>

        {/* Main text */}
        <div className="text-base sm:text-xl font-bold mb-0.5 leading-tight" style={{
        color: '#FFD700',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-40">
          💡 Por solo $8.000 más
        </div>
        <div className="text-white text-xs sm:text-sm mb-2 sm:mb-3 font-medium" data-id="element-41">
          te llevás el Kit PRO completo
        </div>

        {/* PRO features list */}
        <ul className="text-[10px] sm:text-xs text-[#D5DCE5] space-y-0.5 mb-3 sm:mb-4 inline-block text-left" data-id="element-42">
          {PRO_FEATURES.map((f, i) => <li key={i} className="flex items-start gap-1.5" data-id="element-43">
              <span style={{
            color: '#FFD700'
          }} className="shrink-0" data-id="element-44">
                ✓
              </span>
              <span data-id="element-45">{f}</span>
            </li>)}
        </ul>

        {/* Gold CTA */}
        <a href={PRO_URL} target="_blank" rel="noopener noreferrer" className="block w-full py-2.5 sm:py-3 rounded-lg font-extrabold text-[11px] sm:text-sm uppercase tracking-wider transition-transform active:scale-95 hover:brightness-110 shadow-lg" style={{
        background: 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)',
        color: '#1a2744'
      }} data-id="element-46">
          → Agregar PRO por solo $8.000 más
        </a>
      </div>
    </div>;
}
export function PricingSelector({
  variant = 'light'
}: {
  variant?: 'light' | 'cream';
}) {
  const [selectedId, setSelectedId] = useState<'essential' | 'pro'>('pro');
  const selected = PLANS.find(p => p.id === selectedId) || PLANS[1];
  return <div className="bg-white border border-[#D5DCE5] rounded-2xl md:rounded-3xl p-3 sm:p-5 md:p-7 shadow-xl max-w-3xl mx-auto" data-id="element-47">
      {/* Plan selector — both visible at once */}
      <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-3 sm:mb-4" data-id="element-48">
        {PLANS.map(p => {
        const isSelected = selectedId === p.id;
        const isPro = p.id === 'pro';
        return <button key={p.id} type="button" onClick={() => setSelectedId(p.id)} aria-pressed={isSelected} className={`relative text-left rounded-xl md:rounded-2xl p-2.5 sm:p-3.5 transition-all active:scale-[0.98] ${isSelected ? 'bg-[#1E3A5F] border-2 border-[#1E3A5F] shadow-lg shadow-[#1E3A5F]/20 ring-2 ring-[#2D9596]/30 ring-offset-2 ring-offset-white' : 'bg-[#E8EDF3] border-2 border-[#D5DCE5] hover:border-[#2D9596]'} ${isPro && !isSelected ? 'border-[#2D9596]/40' : ''}`} data-id="element-49">
              {p.badge && <div className={`absolute -top-2 sm:-top-2.5 left-1/2 -translate-x-1/2 px-2 sm:px-2.5 py-0.5 rounded-full text-[8px] sm:text-[10px] font-bold uppercase tracking-[0.15em] sm:tracking-[0.18em] whitespace-nowrap shadow-md bg-[#2D9596] text-white ${isSelected ? 'animate-pulse' : ''}`} data-id="element-50">
                  {p.badge}
                </div>}

              <div className="flex items-start gap-1.5 sm:gap-2" data-id="element-51">
                {/* Radio indicator */}
                <div className={`mt-0.5 w-3.5 h-3.5 sm:w-5 sm:h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${isSelected ? 'border-[#2D9596] bg-[#2D9596]' : 'border-[#2D9596]/50'}`} data-id="element-52">
                  {isSelected && <div className="w-1 h-1 sm:w-2 sm:h-2 rounded-full bg-white" data-id="element-53" />}
                </div>
                <div className="flex-1 min-w-0" data-id="element-54">
                  <div className={`text-[8px] sm:text-[10px] tracking-[0.15em] sm:tracking-[0.2em] font-bold uppercase mb-0.5 sm:mb-1 ${isSelected ? 'text-[#D5DCE5]' : 'text-[#2D9596]'}`} data-id="element-55">
                    {p.label}
                  </div>
                  <div className={`text-xs sm:text-base font-bold leading-tight mb-1 ${isSelected ? 'text-white' : 'text-[#1A2433]'}`} style={{
                fontFamily: "'DM Serif Display', serif"
              }} data-id="element-56">
                    {p.title}
                  </div>
                  <div className="flex items-baseline gap-1 sm:gap-1.5 flex-wrap" data-id="element-57">
                    <span className={`text-[10px] sm:text-xs line-through ${isSelected ? 'text-[#D5DCE5]/70' : 'text-[#4A5568]/50'}`} data-id="element-58">
                      {p.oldPrice}
                    </span>
                    <span className={`text-base sm:text-xl font-bold ${isSelected ? 'text-white' : 'text-[#1A2433]'}`} style={{
                  fontFamily: "'DM Serif Display', serif"
                }} data-id="element-59">
                      {p.price}
                    </span>
                  </div>
                </div>
              </div>
            </button>;
      })}
      </div>

      {/* Selected plan features — inline, tight */}
      <div className="bg-[#E8EDF3] border-l-4 border-l-[#2D9596] border-y border-r border-y-[#D5DCE5] border-r-[#D5DCE5] rounded-lg sm:rounded-xl px-3 py-2 sm:px-4 sm:py-3" data-id="element-60">
        <div className="text-[9px] sm:text-[10px] tracking-[0.18em] sm:tracking-[0.2em] text-[#2D9596] font-bold uppercase mb-1.5" data-id="element-61">
          Incluye:
        </div>
        <ul className="space-y-1" data-id="element-62">
          {selected.features.map((f, i) => <li key={`${selected.id}-${i}`} className="flex items-start gap-1.5 text-[11px] sm:text-sm text-[#1A2433] animate-fade-in" data-id="element-63">
              <span className="text-[#2D9596] mt-0.5 shrink-0 text-xs" data-id="element-64">✓</span>
              <span className="font-medium leading-snug" data-id="element-65">{f}</span>
            </li>)}
        </ul>
      </div>

      {/* Upsell banner — only when Esencial is selected */}
      {selectedId === 'essential' && <UpsellBanner data-id="element-66" />}

      {/* Single dynamic CTA */}
      <a href={selected.url} target="_blank" rel="noopener noreferrer" key={selected.id} className={`animate-pulse-glow w-full py-3.5 sm:py-4 md:py-5 rounded-full bg-[#1E3A5F] hover:bg-[#2A4A75] text-white font-bold text-xs sm:text-sm md:text-base transition-all active:scale-95 text-center block shadow-lg tracking-wider uppercase ${selectedId === 'essential' ? 'mt-3 sm:mt-4' : 'mt-3 sm:mt-4'}`} data-id="element-67">
        → Comprar {selected.title} · {selected.price}
      </a>

      <div className="flex flex-wrap justify-center items-center gap-1.5 sm:gap-3 mt-2.5 sm:mt-4 text-[9px] sm:text-xs font-medium text-[#4A5568]" data-id="element-68">
        <span data-id="element-69">🛡️ Garantía 30 días</span>
        <span className="text-[#D5DCE5]" data-id="element-70">|</span>
        <span data-id="element-71">🔒 Pago seguro</span>
        <span className="text-[#D5DCE5]" data-id="element-72">|</span>
        <span data-id="element-73">💳 Mercado Pago</span>
      </div>
    </div>;
}